import React, { useMemo, useCallback, useEffect, ChangeEvent } from 'react';
import styled from 'styled-components';

import TicketStatus from '../TicketStatus';
import {
  PRIORITIES_BY_STATUS,
  STATUSES,
  TICKET_STATUS_PLACEMENT,
  TITLES,
} from '../TicketStatus/constants';
import Checkbox from '../../../Checkbox';
import { ValueOf } from '@utils/tsUtils';

const StyledFilter = styled.ul``;

export type StatusType = {
  value: ValueOf<typeof STATUSES>;
  title: ValueOf<typeof TITLES>;
  priority: ValueOf<typeof PRIORITIES_BY_STATUS>;
};

interface ITicketFilterByStatus {
  className?: string;
  statuses: StatusType[];
  closedReasonStatuses: Array<{ title: string; value: string }>;
  closedReasonValue?: string[];
  closedReasonName: string;
  value?: string[];
  name: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  onClear: (closedReason: this['closedReasonName']) => void;
}

const TicketFilterByStatus = ({
  className,
  statuses,
  closedReasonStatuses = [],
  closedReasonValue,
  closedReasonName,
  onClear,
  value,
  name,
  onChange,
}: ITicketFilterByStatus) => {
  const isClosedStatusChecked = useMemo(
    () => Array.isArray(value) && value.includes('closed'),
    [value]
  );

  const clearClosedReasonFilter = useCallback(() => {
    onClear(closedReasonName);
  }, [onClear, closedReasonName]);

  useEffect(() => {
    if (!isClosedStatusChecked) {
      clearClosedReasonFilter();
    }
  }, [isClosedStatusChecked]);

  return (
    <StyledFilter className={className}>
      {statuses.map(({ priority, value: status }) => {
        const isChecked = Array.isArray(value) && value.includes(status);

        return (
          <li key={status}>
            <Checkbox
              checked={isChecked}
              onChange={onChange}
              name={name}
              value={status}
            >
              <TicketStatus
                priority={priority}
                title={status}
                placement={TICKET_STATUS_PLACEMENT.FILTERS}
              />
            </Checkbox>
          </li>
        );
      })}
      {isClosedStatusChecked &&
        closedReasonStatuses.map(({ value: status, title }) => {
          const isChecked =
            Array.isArray(closedReasonValue) &&
            closedReasonValue.includes(status);

          return (
            <StyledClosedReasonCheckBoxContainer key={status}>
              <Checkbox
                checked={isChecked}
                onChange={onChange}
                name={closedReasonName}
                value={status}
              >
                <span>{title}</span>
              </Checkbox>
            </StyledClosedReasonCheckBoxContainer>
          );
        })}
    </StyledFilter>
  );
};

const StyledClosedReasonCheckBoxContainer = styled.li`
  margin-left: 20px;

  span {
    margin-left: 4px;
  }
`;

export default TicketFilterByStatus;
